import React from 'react'

const Time = ({currentTime}) => {
  return (
    <div>
      <h2>{currentTime}</h2>
    </div>
  )
}

export default Time
